import React, { createContext, useContext, useState, ReactNode } from 'react'

type BasketLockedContextValue = {
  showLocked: boolean
  toggleShowLocked: () => void
  setShowLocked: (v: boolean) => void
}

const BasketLockedContext = createContext<BasketLockedContextValue>({
  showLocked: false,
  toggleShowLocked: () => {},
  setShowLocked: () => {},
})

export const BasketLockedProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [showLocked, setShowLocked] = useState(false)
  return (
    <BasketLockedContext.Provider
      value={{
        showLocked,
        setShowLocked,
        toggleShowLocked: () => setShowLocked(v => !v),
      }}
    >
      {children}
    </BasketLockedContext.Provider>
  )
}

export const useBasketLocked = () => useContext(BasketLockedContext)
export default BasketLockedContext
